import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PoweringYourDigitalPulse from "./sections/PoweringYourDigitalPulse";
import TheCosmicTradeBridge from "./sections/TheCosmicTradeBridge";
import OurGlobalSpecialties from "./sections/OurGlobalSpecialties";
import TheHyderabadApexConnection from "./sections/TheHyderabadApexConnection";
import EcoConsciousValues from "./sections/EcoConsciousValues";
import LatestTradeInsights from "./sections/LatestTradeInsights";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PoweringYourDigitalPulse />
      <TheCosmicTradeBridge />
      <OurGlobalSpecialties />
      <TheHyderabadApexConnection />
      <EcoConsciousValues />
      <LatestTradeInsights />
      <Footer />
    </div>;
}